import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextSale } from '../Sale';
import { User } from '../../../../models/user.model';
import { AppService } from '../../../../models/app.service.model';
import { Company } from '../../../../models/company.model';
import { Settings } from '../../../../models/settings.model';
import { Contact }  from '../../../../models/contact.model';
import { TreasuryAccount } from '../../../../models/treasury.account.model';
import { Service } from '../../../../models/service.model';
import { Product } from '../../../../models/product.model';
import { AccountingAccount } from '../../../../models/accounting.account.model';
import { AccountingEntry } from '../../../../models/accounting.entry.model';

export interface InvoicePageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  userLoggedIn: User | null,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  accountingAccountsForCompany: AccountingAccount[] | null,
  accountingCreditEntriesForCompany: AccountingEntry[] | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  contactsForCompany: Contact[] | null,
  servicesForCompany: Service[] | null,
  productsForCompany: Product[] | null,
  accountingIncomeAccountsForCompany: AccountingAccount[] | null,
  loadSettingsForCompany: Function,
  loadAccountingCreditEntriesForCompany: Function,
  loadContactsForCompany: Function
};

const InvoicePage: React.FunctionComponent<InvoicePageProps> = props => {
  const {setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, accountingAccountsForCompany, accountingCreditEntriesForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, accountingIncomeAccountsForCompany, loadSettingsForCompany, loadAccountingCreditEntriesForCompany, loadContactsForCompany} = UseOutletContextSale()

  return (
    <Outlet context={{setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, accountingAccountsForCompany, accountingCreditEntriesForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, accountingIncomeAccountsForCompany, loadSettingsForCompany, loadAccountingCreditEntriesForCompany, loadContactsForCompany}}></Outlet>
  );
}

export function UseOutletContextInvoice() {
  return useOutletContext<ContexType>()
};

export default InvoicePage;
